import { ISoundsGenre } from 'store/types/audio'
import { TAudioType } from 'types/audio'

export const PROJECT_AUDIO_TYPES: Record<TAudioType, TAudioType> = {
  SOUND: 'SOUND',
  TTS: 'TTS',
  VOICE_OVER: 'VOICE_OVER'
}

const PINNED_GENRES = ['all', 'newest']

export const sortGenresByNameInAlphabeticalOrder = (
  genres: ISoundsGenre[]
): ISoundsGenre[] => {
  const pinned = PINNED_GENRES.map(name =>
    genres.find(g => g.genre === name)
  ).filter((g): g is ISoundsGenre => Boolean(g))
  const rest = genres
    .filter(g => !PINNED_GENRES.includes(g.genre))
    .sort((a, b) => a.genre.localeCompare(b.genre))
  return [...pinned, ...rest]
}
